import { SortableFilter }          from './../common/sortable-filter';

export class MonitoringSortableFilter extends SortableFilter {
}

export class RecipeSortableFilter extends SortableFilter {
    public dateFromValue: Date = null;

    public dateToValue: Date = null;

    public dateFrom: string = null;

    public dateTo: string = null;

    public companyUid: string = null;

    public documentType: any = null;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/monitoring/monitoring-sortable-filter.ts